import React, { memo } from "react";
import { FormattedNumber } from "react-intl";
import { renderValueWithTooltip } from "./GridCellWithTooltip.js";
const GridNumberFormatter = memo(({ value }) => {
  return /* @__PURE__ */ React.createElement(FormattedNumber, { value: value ?? 0 });
});
memo(({ value }) => {
  return /* @__PURE__ */ React.createElement(FormattedNumber, { value: value ?? 0, style: "percent" });
});
const renderGridNumber = (params) => {
  const defaultValue = params.value;
  return renderValueWithTooltip(
    defaultValue !== null && defaultValue !== void 0 ? /* @__PURE__ */ React.createElement(GridNumberFormatter, { value: defaultValue }) : defaultValue
  );
};
export {
  GridNumberFormatter,
  renderGridNumber
};
//# sourceMappingURL=NumberCell.js.map
